import React from "react";
import { useForm, watch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import useSignupStore from "../../../store/SignUpStore";
import { accountSchema } from "../../../utils/accountSchema";

const AccountInfoPage = () => {
    const { loginId, password, setAccountInfo } = useSignupStore();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm({
        resolver: zodResolver(accountSchema),
        defaultValues: {
            loginId: loginId || "",
            password: password || "",
            passwordConfirm: "",
        },
        mode: "onChange",
    });

    const passwordConfirm = watch("passwordConfirm")

    const onSubmit = (data) => {
        setAccountInfo({
            loginId: data.loginId,
            password: data.password,
        });
        navigate("/signup/personal-info");
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4 mt-[150px]">
            <div className="w-full max-w-md space-y-8">
                <div className="text-center">
                    <h1 className="text-2xl font-bold">회원가입</h1>
                    <p className="mt-2 text-gray-600">
                        아이디와 비밀번호를 입력해주세요
                    </p>
                </div>

                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="mt-8 space-y-4"
                >
                    <div>
                        <input
                            {...register("loginId")}
                            type="text"
                            placeholder="아이디 입력"
                            className="w-full h-[60px] px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        {errors.loginId && (
                            <p className="mt-1 text-sm text-red-500">
                                {errors.loginId.message}
                            </p>
                        )}
                    </div>

                    <div>
                        <input
                            {...register("password")}
                            type="password"
                            placeholder="비밀번호 입력"
                            className="w-full h-[60px] px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        {errors.password && (
                            <p className="mt-1 text-sm text-red-500">
                                {errors.password.message}
                            </p>
                        )}
                    </div>

                    <div>
                        <input
                            {...register("passwordConfirm")}
                            type="password"
                            placeholder="비밀번호 재확인"
                            className="w-full h-[60px] px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        {errors.passwordConfirm && (
                            <p className="mt-1 text-sm text-red-500">
                                {errors.passwordConfirm.message}
                            </p>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={!passwordConfirm}
                        className="w-full h-[60px] py-3 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 mt-6 disabled:opacity-50"
                    >
                        다음
                    </button>
                </form>
            </div>

            <div className="flex justify-center mt-[195px]">
                <img
                    src="/images/softcat_new_logo.png"
                    alt=" "
                    className="w-[180px] h-[50px]"
                />
            </div>
        </div>
    );
};

export default AccountInfoPage;